<div class="report-form">
  <div class="card-header">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <app-bigger-screen-required></app-bigger-screen-required>
  <div class="hide-on-phone">
    <div class="spacer-small"></div>
    <div class="buttons" [ngClass]="stickyButtons ? 'stickyButtons' : ''">
      <span [routerLink]="'/bewind/'+clientId+'/rapportage'" class="btn arrow-left btn-left">terug</span>
      <span (click)="concept()" class="btn glasses">rapport bekijken</span>
      <button (click)="finish()"
              (mouseenter)="showErrors = true;"
              *ngIf="showFinalButton()"
              [matTooltipDisabled]="!form.invalid"
              class="btn check"
              matTooltip="Niet alle verplichte velden zijn ingevuld.">definitief rapport maken
      </button>
      <div class="report-state">
        <span *ngIf="isPending() || isSaving()">
          <mat-icon class="saving-icon">loop</mat-icon>bezig met opslaan
        </span>
        <span *ngIf="isSaved()">
          <mat-icon class="saving-icon">cloud_done</mat-icon>
          alles is opgeslagen
        </span>
      </div>
    </div>
    <div class="card-body pt0">
      <form class="form form-no-width full-width" #form="ngForm" ngForm>
        <div *ngFor="let question of questions">
          <h2 *ngIf="question.category != currentCategory && setCurrentCategory(question.category)" class="mt70">{{question.category}}</h2>
          <app-question (recalculate)="calculateTotals()"
                        (save)="saveAnswer($event)"
                        (unsaved)="unsaved($event)"
                        [answers]="answers"
                        [questions]="questions"
                        [model]="model"
                        [question]="question"
                        [reportName]="service.getReportName(reportTypeCode)"
                        [showError]="showErrors"
                        [reportTypeCode]="reportTypeCode"></app-question>
        </div>
      </form>
    </div>
    <div class="spacer"></div>
  </div>
</div>
